<template>
  <section class="page-container">
    <div class="flex flex-align-center flex-sb-center">
      <div class="total">
        <div
          v-for="(value,i) in statistics"
          :key="i"
          class="item">
          <span class="num">{{value.val}}</span>
          <span>{{value.name}}</span>
        </div>
      </div>
      <div
        v-if="showUpdate"
        class="flex">
        <v-button
          gray
          @click="showUpdate = false"
        >Cancel</v-button>
        <v-button
          class="mg-l-8"
          green
          @click="handleUpdate"
        >Update</v-button>
      </div>
      <v-button
        v-else
        gray
        @click="showUpdate = true"
      >Multiple Update</v-button>
    </div>
    <div class="filter-top">
      <!--      <span>Search</span>-->
      <v-input
        v-model="search"
        placeholder="Ref., Recipient, Phone No., Tracking No."
        @keyEnter="filterData" />
    </div>
    <div class="filter-card">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="changeDate" />
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('status')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('status')">None</span>
            </span>
            <div class="flex-sb">
              <div class="form-half">
                <v-checkbox-group
                  v-model="status"
                  :list="statusList"
                  @change="filterData">
                  <template #default="{ item }">
                    <span class="flex-sb-center">
                      <span
                        class="circle"
                        :class="{
                          'yellow': item.id == 0,
                          'red': item.id == 2,
                          'green': item.id == 1,
                        }"></span>
                      <span>{{ item['name'] }}</span>
                    </span>
                  </template>
                </v-checkbox-group>
              </div>
            </div>
          </div>
          <!--          <div class="form-item">-->
          <!--            <span>-->
          <!--              Channel-->
          <!--              <span-->
          <!--                class="all"-->
          <!--                @click="handlerSelectAll('source')">All</span>-->
          <!--              <span-->
          <!--                class="all"-->
          <!--                @click="handlerNoneAll('source')">None</span>-->
          <!--            </span>-->
          <!--            <span>-->
          <!--              <v-checkbox-group-->
          <!--                v-model="source"-->
          <!--                :list="channelList"-->
          <!--                :isColumn="false"-->
          <!--                @change="filterData"-->
          <!--              />-->
          <!--            </span>-->
          <!--          </div>-->
        </div>
        <div class="filter-right">
          <div class="form-item">
            <span>
              Need the professional licensing agency documents services?
            </span>
            <div class="flex-sb">
              <div class="form-half">
                <v-radio-group
                  v-model="need_ind"
                  :list="needList"
                  block
                  @change="filterData">
                </v-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        @selection-change="handleSelectionChange"
        @row-click="handleRow"
      >
        <el-table-column
          v-if="showUpdate"
          type="selection"
          align="center"
          width="45">
        </el-table-column>
        <el-table-column
          width="60px"
          align="center">
          <template>
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="gift"
                  class="icon-color"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Created Date">
          <template #default="{row}">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.created_date.split(" ")[0] }}</span><br>
              <span> {{ row.created_date.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
            <!--            <p class="channel">{{row.source==1?'Web':'AlipayHK'}}</p>-->
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Updated">
          <template #default="{row}">
            <p>{{ row.updated_date.split(" ")[0]}}</p>
            <p>{{ row.updated_date.split(" ")[1]}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="Gifts & Policy">
          <template #default="{row}">
            <div class="flex">
              <div class="mg-r-8">
                <p>{{row.id_number}}</p>
                <p class="liter-text tag-border">{{row.rgtn_no}}</p>
              </div>
              <p class="product-name">{{row.plan}}</p>

            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Account Name">
          <template #default="{ row }">
            <span class="break-word">{{row.isrd_nm}}</span>
            <p class="liter-text">{{row.email}}</p>
            <p class="liter-text">{{row.mobile_no}}</p>
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
          :show-overflow-tooltip="true"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin status-height">
              <p>
                <span
                  class="span-status"
                  :class="{
                    'yellow-dark': row.status == 0,
                    'green': row.status == 1,
                    'red': row.status == 2,
                  }">
                  {{ row.status_language }}
                </span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
        >
          <template #default="{ row }">
            <div class="flex-algin status-height">
              <p
                v-if="!showUpdate"
                @click.stop="handleAloneUpdate(row)">
                <span class="blue">Update</span>
              </p>
            </div>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
    <exclusive-update
      v-model="isShow"
      :is-hzmb="true"
      :select-arr="selectData"
      @update="handleRefresh"></exclusive-update>
  </section>
</template>

<script>
import {getHzmbList} from '@/api/hzmb'
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'
import MixinOptions from '@/mixins/options'
import MinxinFormat from '@/mixins/format'
import exclusiveUpdate from '@/views/records/micropolicy/components/dialog/exclusiveUpdate'

export default {
  name: 'PromoHzmbList',
  components:{
    exclusiveUpdate
  },
  mixins: [MixinOptions,MinxinFormat],
  data () {
    return {
      search: null,
      date: [],
      status: [],
      showUpdate:false,
      isShow:false,
      tableData:[],
      selectData:[],
      source: [],
      need_ind: '',
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      statistics:{
        total: {
          name: 'Total Items',
          val: 0
        },
      }
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
    statusList(){
      let {hanberg_status} = this.globalOptions||{}
      return hanberg_status||[]
    },

    channelList(){
      return [
        {
          id:1,
          name:'Web'
        },
        {
          id:2,
          name:'AlipayHK'
        }
      ]
    },
    needList(){
      return [
        {
          id:'',
          name:'All'
        },
        {
          id:1,
          name:'Yes'
        },
        {
          id:0,
          name:'No'
        },
      ]
    },
  },
  watch:{
    property: {
      immediate: true,
      handler() {
        let {policy={}} =  this.selectFilterData||{}
        Object.keys(policy).forEach(item=>{
          this[item] = policy[item]
        })
        this.setFilterData(policy||{})
        this.network().getList()
      }
    },
    date:{
      immediate: true,
      handler(){
        this.$emit('changeDate',this.date)
      }
    }
  },
  created(){
    this.network().getList()
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    handleSelectionChange(val){
      this.selectData =val.reduce((result,item)=>{
        let {id} = item||{}
        result.push(id)
        return result
      },[])
    },
    handleRow(row){
      const { id, class_id, product_id} = row
      this.$router.push(`/records/micropolicy/promo-hzmb/${id}`)
    },
    handleUpdate(){
      this.isShow = true
    },
    handleAloneUpdate(row){
      let {id} = row
      this.selectData = [id]
      this.isShow = true
    },
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },
    handleRefresh(){
      this.filterData()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getList()
    },

    handlerSelectAll(target){
      let origin = ''
      switch(target) {
        case 'status':
          origin = 'statusList'
          break
        case 'source':
          origin = 'channelList'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },

    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    handlerDown() {
      this.network().getList({
        is_export: 1
      })
    },

    network(){
      return {
        getList: async (otherParams) => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
            status: this.status,
            source: this.source,
            need_ind: this.need_ind,
            ...otherParams
          }
          if(otherParams && otherParams.is_export == 1){
            const res = await getHzmbList(params,{
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
          }else
          {
            const { data } = await getHzmbList(params)
            this.pageConfig.currentPage = data.current_page
            this.pageConfig.total = data.total
            this.tableData = data.data
            this.statistics.total.val = data.total
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  .break-word{
    word-break: break-word;
  }
  .total{
    //margin-bottom: 20px;
    .item{
      display: inline-block;
      margin-right: 20px;
      .num{
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        padding: 0 10px;
      }
    }
  }
  .filter-top{
    margin-top:30px;
    margin-bottom: 30px;
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.yellow {
        background: #E36209;
      }
      &.green {
        background: #28A745;
      }
      &.red {
        background: #D73A49;
      }
    }
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;

      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        width: 290px;
      }
      .filter-right {
        padding-left: 10px;
        border-left: 1px solid #E1E4E8;
        flex: 1;
      }
    }
  }
  .transparent{
    .product-name{
      word-break: break-word;
      font-size: 14px;
      font-weight: 600;
    }
    .ref{
      font-size: 12px;
      &>span{
        font-weight: 600;
        padding-right: 5px;
      }
    }
    .no-line{
      text-decoration: none;
      color: #606266;
    }
  }
  .span-status {
    display: inline-block;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.yellow-dark {
      background: #E36209;
    }
    &.red{
      background: #D73A49;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 20px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        padding: 0;
        color: #24292E;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
        .liter-text{
          color: #6A737D;
          font-size: 12px;
          &.tag-border{
            border: 1px solid #dddfe7;
            border-radius: 4px;
            text-align: center;
            line-height: 18px;
          }
        }
      }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }


}
::v-deep .el-table-column--selection{
  .cell{
    padding-left: 15px!important;
  }
}
.mg-r-8{
  margin-right: 8px;
}
.channel{
  font-size: 12px;
  font-weight: 600;
  color: #586069;
}
</style>
